import { NodeType } from '@ui/__generated__/graphql'
import { SourceHandleEnum, TargetHandleEnum } from '@ui/interfaces'
import { uuid } from '@ui/lib/utils'
import { useNodeAndEdgeStore } from '@ui/stores'

import { createEdge, createNode } from '../helpers'

export const splitNode = ({
  edgeIds,
  type,
  description,
}: {
  edgeIds: string[]
  type?: NodeType
  description?: string
}) => {
  const nodes = useNodeAndEdgeStore.getState().nodes
  const edges = useNodeAndEdgeStore.getState().edges
  const setNodes = useNodeAndEdgeStore.getState().setNodes
  const setEdges = useNodeAndEdgeStore.getState().setEdges
  const setRefreshLayout = useNodeAndEdgeStore.getState().setRefreshLayout

  const currentNode = nodes.find((node) => node.id === edges.find((edge) => edge.id === edgeIds[0])?.source)
  if (!currentNode) {
    return
  }

  const childNode = nodes.find((node) => node.id === edges.find((edge) => edge.id === edgeIds[0])?.target)
  if (!childNode) {
    return
  }

  const newNodeId = uuid()

  const logEdge = createEdge({
    source: currentNode.id,
    target: newNodeId,
    targetHandle: TargetHandleEnum.TARGET_LOGS,
    sourceHandle: SourceHandleEnum.SOURCE_LOGS,
    placeholder: true,
  })

  const spanEdge = createEdge({
    source: currentNode.id,
    target: newNodeId,
    targetHandle: TargetHandleEnum.TARGET_SPANS,
    sourceHandle: SourceHandleEnum.SOURCE_SPANS,
    placeholder: true,
  })

  const metricsEdge = createEdge({
    source: currentNode.id,
    target: newNodeId,
    targetHandle: TargetHandleEnum.TARGET_METRICS,
    sourceHandle: SourceHandleEnum.SOURCE_METRICS,
    placeholder: true,
  })
  setEdges((edges) => {
    return edges.concat([logEdge, spanEdge, metricsEdge])
  })

  const newNode = createNode({
    nodeId: newNodeId,
    nodeType: type || NodeType.Placeholder,
    parentNodeId: currentNode.id,
    description,
  })

  setNodes((nodes) => {
    return nodes.concat([newNode])
  })

  setRefreshLayout(true)

  return newNodeId
}
